import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Badge, Spinner } from 'react-bootstrap';
import { FaRobot, FaBolt, FaChevronRight, FaShieldAlt, FaMicrochip, FaCheckCircle, FaPercentage, FaWallet } from 'react-icons/fa';
import api from '../services/api';

const Products = ({ setCurrentView, setPreSelectedBot, isAuthenticated }) => {
    const [bots, setBots] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBots = async () => {
            try {
                const res = await api.get('/api/public/pricing-data');
                console.log("🔍 [DEBUG] Dữ liệu từ Server:", res.data);
                if (res.data.success) {
                    setBots(res.data.botSetups || []);
                }
            } catch (err) {
                console.error("Lỗi tải danh sách sản phẩm");
            } finally {
                setLoading(false);
            }
        };
        fetchBots();
    }, []);

    const handleSelectBot = (bot) => {
    // 1. Lưu vào State tổng của App (nếu có)
    if (setPreSelectedBot) setPreSelectedBot(bot);
    
    // 2. Lưu vào bộ nhớ trình duyệt để đề phòng F5
    localStorage.setItem('pending_bot_selection', JSON.stringify(bot));
    
    // 3. Chuyển hướng
    if (!isAuthenticated) {
        setCurrentView('register');
    } else {
        // Ta thêm một chút delay hoặc state để Pricing biết là cần Auto-Scroll
        setCurrentView('pricing');
    }
};

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh', backgroundColor: '#020617'}}>
            <Spinner animation="grow" variant="warning" />
        </div>
    );

    return (
        <Container fluid className="py-5 px-lg-5" style={{ background: '#020617', minHeight: '100vh', color: '#fff' }}>
            
            {/* HEADER */}
            <div className="text-center mb-5 pb-4 position-relative">
                <div className="position-absolute" style={{ top: '-50px', left: '50%', transform: 'translateX(-50%)', width: '300px', height: '100px', background: 'rgba(234, 179, 8, 0.1)', filter: 'blur(80px)', zIndex: 0 }}></div>
                <Badge bg="none" className="mb-4 px-4 py-2 text-gold-highlight border border-warning border-opacity-50 rounded-pill font-mono shadow-glow uppercase" style={{ letterSpacing: '3px', fontSize: '0.75rem' }}>
                    <FaMicrochip className="me-2 animate-pulse"/> STRATEGIC_ASSET_CATALOG
                </Badge>
                
                <h1 className="fw-black text-gold-highlight uppercase font-main mb-3 py-2" 
                    style={{ 
                        fontSize: 'clamp(2rem, 5vw, 3.5rem)', 
                        lineHeight: '1.4', 
                        letterSpacing: '-1px' 
                    }}>
                    DANH MỤC SẢN PHẨM BOT
                </h1>
            </div>

            <Row className="g-4">
                {bots.map((bot, idx) => {
                    const isPrepaid = bot.billing_type === 'prepaid' || (Number(bot.base_price_per_100_usd) > 0);
                    
                    return (
                        <Col lg={6} key={bot._id || idx}>
                            <Card className="feature-card border-0 h-100 overflow-hidden" 
                                  style={{ background: '#0b1221', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px' }}>
                                
                                <Card.Body className="p-4 p-lg-5">
                                    <Row className="align-items-center">
                                        <Col md={7} className="text-center text-md-start"> 
                                            <div className="d-flex flex-column flex-md-row align-items-center mb-4">
                                                <div className="feature-icon fs-1 mb-3 mb-md-0 me-md-3 text-gold-highlight">
                                                    <FaRobot />
                                                </div>
                                                
                                                <div className="text-center text-md-start">
                                                    <h3 className="text-white fw-black mb-0 font-main uppercase" 
                                                        style={{ fontSize: '1.5rem', cursor: 'pointer', lineHeight: '1.4' }} 
                                                        onClick={() => handleSelectBot(bot)}>
                                                        {bot.name}
                                                    </h3>
                                                    <Badge bg="none" className="text-warning font-mono p-0 mt-1 d-block d-md-inline-block" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
                                                        <FaBolt className="me-1"/>{bot.symbol || 'XAUUSD'} / V.STABLE
                                                    </Badge>
                                                </div>
                                            </div>
                                            
                                            {/* ĐÃ CHỈNH SỬA: Chuyển text-secondary sang text-white với opacity cao hơn */}
                                            <p className="text-white font-main mb-4" style={{ lineHeight: '1.6', opacity: 0.9, minHeight: '50px' }}>
                                                {bot.description}
                                            </p>
                                            
                                            {/* ĐÃ CHỈNH SỬA: Chuyển text-white-50 sang text-white */}
                                            <div className="d-flex justify-content-center justify-content-md-start gap-3 mb-4 mb-md-0">
                                                <div className="small text-white font-mono" style={{ opacity: 0.8 }}><FaShieldAlt className="text-info me-1"/> SECURE</div>
                                                <div className="small text-white font-mono" style={{ opacity: 0.8 }}><FaCheckCircle className="text-success me-1"/> VERIFIED</div>
                                            </div>
                                        </Col>

                                        <Col md={5} className="ps-md-4 border-start border-secondary border-opacity-10">
                                            <div className="stats-glass-panel p-4 text-center mb-4" style={{ background: 'rgba(15, 23, 42, 0.4)', borderRadius: '18px', border: '1px solid rgba(255,255,255,0.1)' }}>
                                                {!isPrepaid ? (
                                                    <>
                                                        <div className="stat-label mb-2"><FaPercentage className="me-1"/> HỢP TÁC CHIA LÃI</div>
                                                        <div className="stat-value text-emerald">
                                                            {bot.profit_share 
                                                                ? (bot.profit_share.toString().includes('%') ? bot.profit_share : `${bot.profit_share}%`) 
                                                                : '20%'
                                                            }
                                                        </div>
                                                        {/* ĐÃ CHỈNH SỬA: Chữ nhỏ WIN-WIN rõ hơn */}
                                                        <div className="small text-white mt-1 font-mono" style={{fontSize: '0.6rem', opacity: 0.7}}>WIN-WIN MODEL</div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="stat-label mb-2"><FaWallet className="me-1"/> THUÊ TRẢ TRƯỚC</div>
                                                        <div className="stat-value text-gold-highlight">
                                                            {Number(bot.base_price_per_100_usd).toLocaleString()}đ
                                                        </div>
                                                        {/* ĐÃ CHỈNH SỬA: Chữ nhỏ FIXED FEE rõ hơn */}
                                                        <div className="small text-white mt-1 font-mono" style={{fontSize: '0.6rem', opacity: 0.7}}>FIXED FEE / 100$</div>
                                                    </>
                                                )}
                                            </div>

                                            <Button variant="warning" className="btn-luxury-gold w-100 py-3 fw-black border-0" 
                                                    onClick={() => handleSelectBot(bot)}
                                                    style={{ borderRadius: '10px' }}>
                                                CHỌN 
                                                <FaChevronRight className="ms-2" size={10}/>
                                            </Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    );
                })}
            </Row>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&family=Fira+Code:wght@400;700&display=swap');
                .font-main { font-family: 'Inter', sans-serif !important; }
                .font-mono { font-family: 'Fira Code', monospace !important; }
                .fw-black { font-weight: 900; }
                
                .text-gold-highlight { 
                    background: linear-gradient(135deg, #eab308 0%, #fef3c7 50%, #eab308 100%); 
                    -webkit-background-clip: text; 
                    -webkit-text-fill-color: transparent; 
                    background-clip: text; 
                    display: inline-block; 
                    width: 100%;
                }
                
                .btn-luxury-gold { background: linear-gradient(135deg, #eab308 0%, #fbbf24 100%) !important; color: #000 !important; }
                .feature-card { transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); position: relative; }
                .feature-card:hover { border-color: #fbbf24 !important; transform: translateY(-10px); }
                .stat-value { font-weight: 900; font-size: 1.8rem; letter-spacing: -1px; line-height: 1.2; }
                
                /* Tăng độ sáng cho label nhãn tĩnh */
                .stat-label { font-size: 0.65rem; letter-spacing: 2px; color: #cbd5e1; font-weight: 800; text-transform: uppercase; }
                
                .text-emerald { color: #34d399 !important; text-shadow: 0 0 15px rgba(52, 211, 153, 0.4); }
                .animate-pulse { animation: pulse 2s infinite; }
                @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.4; } 100% { opacity: 1; } }
            `}</style>
        </Container>
    );
};

export default Products;